// Module
var code = "<h4 class=\"flow-title-publicmap\">{{ $ctrl.processMapName }}</h4> <public-map process-map-id=\"$ctrl.processMapId\"></public-map> ";
// Exports
export default code;